/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a histogram from a list of numbers — see the distribution, no sign-up.`)
};

const es_hist_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un histograma a partir de una lista de números — visualiza la distribución, sin registro.`)
};

const de_hist_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie ein Histogramm aus einer Liste von Zahlen — sehen Sie die Verteilung, keine Anmeldung erforderlich.`)
};

const nl_hist_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een histogram van een lijst getallen — bekijk de verdeling, geen registratie nodig.`)
};

const fr_hist_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un histogramme à partir d'une liste de nombres — visualisez la distribution, sans inscription.`)
};

const it_hist_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un istogramma da un elenco di numeri — vedi la distribuzione, senza registrazione.`)
};

const pt_br2_hist_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um histograma a partir de uma lista de números — veja a distribuição, sem cadastro.`)
};

const pt_hist_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um histograma a partir de uma lista de números — veja a distribuição, sem registo.`)
};

const ja_hist_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値のリストからヒストグラムを作成します — 分布を確認、登録不要。`)
};

const zh_hist_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据一组数字创建直方图——查看数据分布，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_tool_description", locale)
	if (locale === "en") return en_hist_tool_description(inputs)
	if (locale === "es") return es_hist_tool_description(inputs)
	if (locale === "de") return de_hist_tool_description(inputs)
	if (locale === "nl") return nl_hist_tool_description(inputs)
	if (locale === "fr") return fr_hist_tool_description(inputs)
	if (locale === "it") return it_hist_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_hist_tool_description(inputs)
	if (locale === "pt") return pt_hist_tool_description(inputs)
	if (locale === "ja") return ja_hist_tool_description(inputs)
	return zh_hist_tool_description(inputs)
};